// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"93fe7ed120e28cd3c0d7","6980":"f123df4b4bb8e927a80e"}[chunkId] + ".js";
};